(() => {
  const formSelector = '.respecto-footer-safe__newsletter-form';
  const emailSelector = 'input[type="email"]';
  const scrollStorageKey = 'respectoNewsletterScrollPosition';
  const isGeorgian = document.documentElement.lang.split('-')[0] === 'ka';

  function validationMessage(input) {
    if (!isGeorgian) return '';
    if (input.validity.valueMissing) return 'გთხოვთ, შეავსოთ ელ.ფოსტის ველი';
    if (input.validity.typeMismatch) return 'გთხოვთ, შეიყვანოთ სწორი ელ.ფოსტის მისამართი';
    return '';
  }

  function saveScrollPosition() {
    try {
      sessionStorage.setItem(scrollStorageKey, JSON.stringify({
        x: window.scrollX,
        y: window.scrollY,
        path: window.location.pathname,
        savedAt: Date.now(),
      }));
    } catch (_) {
      // The native Shopify form remains fully functional if storage is unavailable.
    }
  }

  function restoreScrollPosition() {
    let saved;
    try {
      saved = JSON.parse(sessionStorage.getItem(scrollStorageKey) || 'null');
    } catch (_) {
      saved = null;
    }

    if (!saved || saved.path !== window.location.pathname || Date.now() - saved.savedAt > 30000) {
      try { sessionStorage.removeItem(scrollStorageKey); } catch (_) {}
      return;
    }

    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    const restore = () => {
      const documentHeight = Math.max(
        document.body.scrollHeight,
        document.documentElement.scrollHeight
      );
      window.scrollTo({ left: 0, top: documentHeight, behavior: 'auto' });
    };

    restore();
    requestAnimationFrame(() => requestAnimationFrame(restore));
    window.addEventListener('pageshow', restore, { once: true });
    window.addEventListener('load', restore, { once: true });
    [50, 150, 350, 800, 1500, 2500, 3500].forEach((delay) => window.setTimeout(restore, delay));
    window.setTimeout(() => {
      restore();
      try { sessionStorage.removeItem(scrollStorageKey); } catch (_) {}
    }, 4000);
  }

  function bind(form) {
    if (form.dataset.respectoNewsletterBound === 'true') return;
    form.dataset.respectoNewsletterBound = 'true';
    const input = form.querySelector(emailSelector);

    if (input && isGeorgian) {
      input.addEventListener('invalid', () => {
        input.setCustomValidity('');
        input.setCustomValidity(validationMessage(input));
      });
      input.addEventListener('input', () => input.setCustomValidity(''));
    }

    // Keep Shopify's native refresh and response, but remember the exact viewport.
    form.addEventListener('submit', saveScrollPosition);
  }

  function init() {
    restoreScrollPosition();
    document.querySelectorAll(formSelector).forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll(formSelector).forEach(bind);
  });
})();

// Keep the submitted language marker equal to the rendered newsletter language.
document.addEventListener("submit", function (event) {
  var form = event.target;
  if (!form || !form.querySelector) return;
  var tags = form.querySelector("input[name=\"contact[tags]\"][data-respecto-newsletter-tags]");
  if (tags) {
    var language = document.documentElement.lang.split("-")[0] === "ka" ? "ka" : "en";
    tags.value = tags.getAttribute("data-respecto-newsletter-tags") + ",respecto-signup-" + Date.now() + "-" + language;
  }
}, true);
